// components/MobileControls.jsx
import React from 'react';

const MobileControls = ({ onMove, isWon }) => {
  return (
    <div className="mobile-controls bg-light border-top p-3">
      <div className="text-center mb-2">
        <small className="text-muted">Swipe controls</small>
      </div>
      
      <div className="d-flex flex-column align-items-center">
        {/* Up Button */}
        <button
          className="btn btn-primary control-btn mb-2"
          onClick={() => onMove(0, -1)}
          disabled={isWon}
          style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            fontSize: '24px'
          }}
        >
          ↑
        </button>

        <div className="d-flex gap-3 mb-2">
          {/* Left Button */}
          <button
            className="btn btn-primary control-btn"
            onClick={() => onMove(-1, 0)}
            disabled={isWon}
            style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              fontSize: '24px'
            }}
          >
            ←
          </button>

          {/* Right Button */}
          <button
            className="btn btn-primary control-btn"
            onClick={() => onMove(1, 0)}
            disabled={isWon}
            style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              fontSize: '24px'
            }}
          >
            →
          </button>
        </div>

        {/* Down Button */}
        <button
          className="btn btn-primary control-btn"
          onClick={() => onMove(0, 1)}
          disabled={isWon}
          style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            fontSize: '24px'
          }}
        >
          ↓
        </button>
      </div>

      <div className="text-center mt-3">
        <small className="text-muted">Or swipe on the game board</small>
      </div>
    </div>
  );
};

export default MobileControls;